import { Injectable } from '@angular/core';
import { CoreApiResource, createQueryBuilder } from '../core-api';
import { WalletDto, WalletPostBody } from '@mkp/shared/models';

type WalletAvailableFilter = {
  'walletAccesses.account.id': '==' | '!=';
  'walletAccesses.role': '==' | '!=';
  state: ['!=', '=='];
  name: '=@' | '!@';
};

type WalletAvailableSort = {
  'walletAccesses.account.id': 'asc';
  state: 'desc' | 'asc';
};

export const walletQueryBuilder = createQueryBuilder<WalletAvailableFilter, WalletAvailableSort>;

@Injectable({ providedIn: 'root' })
export class WalletResource extends CoreApiResource<WalletDto, WalletPostBody> {
  constructor() {
    super('wallet');
  }
}
